import React, {useEffect, useState} from 'react';
import {ProductSpecificationCollectionDto} from "../../product-models";
import {useCollapse} from "react-collapsed";
import {useDispatch} from "react-redux";
import {collapseSpec, expandSpec} from "../../store/actionCreators/specDisplayManagement";
import {useTypedSelector} from "../../hooks/useTypeSelector";

interface SpecCollectionProps {
    collection: ProductSpecificationCollectionDto;
}

const SpecCollection = React.memo((props:SpecCollectionProps) => {
    const dispatch = useDispatch();
    
    const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded: props.collection.IsExpanded })
    
    const toggleCollapseExpand = () => {
        if(props.collection.IsExpanded) {
            dispatch(collapseSpec(props.collection.CollectionName));
        } else {
            dispatch(expandSpec(props.collection.CollectionName));
        }
    }
    
    return (
        <>
            <h3 {...getToggleProps({
                onClick: () => toggleCollapseExpand(),
            })}
            >
                <span className={props.collection.IsExpanded? 'open-close-icon open' : 'open-close-icon close'}></span>
                {props.collection.CollectionName}
            </h3>

            <section {...getCollapseProps()}>
                <table>
                    <tbody>
                        {props.collection.Specs.map((spec, index) => {
                            return (
                                <tr key={`${props.collection.CollectionName} ${spec.SpecKey}`}>
                                    <td>{spec.SpecKey}</td>
                                    <td><div dangerouslySetInnerHTML={{__html: spec.SpecValue }}></div></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </section>
        </>
    )
})

export default SpecCollection